<template>
  <v-card>
    <v-container fluid class="liquidation-query-toolbar pa-0">
      <div class="liquidation-toolbar-outer pa-2">
        <v-btn flat icon color="primary" class="liquidation-toolbar-refresh" v-on:click="refresh">
          <v-icon>cached</v-icon>
        </v-btn>
        <div class="liquidation-toolbar-group-right">
          <v-text-field
            id="searchBox"
            class="liquidation-toolbar-search"
            single-line
            v-model="searchValue"
            @keydown.enter="enter"
            label="Buscar"
            placeholder="Buscar"
            append-icon="search"
            light
            hide-details
          ></v-text-field>
          <v-menu
            ref="menuPayFrom"
            lazy
            :close-on-content-click="false"
            v-model="menuPayFrom"
            transition="scale-transition"
            offset-y
            min-width="290px"
            :return-value.sync="payDateFrom"
            class="liquidation-toolbar-date"
          >
            <v-text-field
              slot="activator"
              label="Fecha inicio"
              placeholder="dd/mm/aaaa"
              :value="payDateFromDisplay"
              append-icon="event"
              readonly
              hide-details
              single-line
            ></v-text-field>
            <v-date-picker
              v-model="payDateFrom"
              scrollable
              locale="es-la"
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menuPayFrom = false">Cancelar</v-btn>
              <v-btn flat color="primary" @click="$refs.menuPayFrom.save(payDateFrom); menuPayFrom = false">Ok</v-btn>
            </v-date-picker>
          </v-menu>
          <v-menu
            ref="menuPayTo"
            lazy
            :close-on-content-click="false"
            v-model="menuPayTo"
            transition="scale-transition"
            offset-y
            min-width="290px"
            :return-value.sync="payDateTo"
            class="liquidation-toolbar-date"
          >
            <v-text-field
              slot="activator"
              label="Fecha final"
              placeholder="dd/mm/aaaa"
              :value="payDateToDisplay"
              append-icon="event"
              readonly
              hide-details
              single-line
            ></v-text-field>
            <v-date-picker
              v-model="payDateTo"
              scrollable
              locale="es-la"
            >
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="menuPayTo = false">Cancelar</v-btn>
              <v-btn flat color="primary" @click="$refs.menuPayTo.save(payDateTo); menuPayTo = false">Ok</v-btn>
            </v-date-picker>
          </v-menu>
          <div class="liquidation-toolbar-actions">
            <v-btn small class="grey lighten-2 liquidation-toolbar-btn" @click="applyDateFilter">Filtrar</v-btn>
            <v-btn small class="grey lighten-2 liquidation-toolbar-btn" @click="clearDateFilter">Limpiar</v-btn>
          </div>
        </div>
      </div>
    </v-container>
    <v-card-text style="padding-top:0px">
      <v-data-table :items="commissionsLiquidation" :headers="headers" class="v-table-list theme--light"
        :custom-sort="customSort" >
        <template slot="items" scope="props">
          <tr :active="props.selected" @click="props.selected = !props.selected">
            <td width="1%">
              <v-checkbox hide-details v-model="selectRow[props.index]"
                @change="uniqueCheck(props.item.number, props.index)"></v-checkbox>
            </td>
            <td class="text-xs-left cut-text">{{ moment(props.item.creationDate, "DD/MM/YYYY HH:mm").format('DD/MM/YYYY HH:mm')}}</td>
            <td class="text-xs-left cut-text">{{ props.item.number }}</td>
            <td class="text-xs-left cut-text">{{  props.item.vtAgency === "0" ? 'Todas' : props.item.vtAgency }}</td>
            <td class="text-xs-left cut-text">{{ props.item.apsCode }}</td>
            <td class="text-xs-left cut-text">{{ props.item.printedTotal | currency }}</td>
            <td class="text-xs-left cut-text">{{ props.item.status }}</td>
            <td class="text-xs-left cut-text">{{ props.item.payDate }}</td>
            <td class="text-xs-left cut-text">{{ props.item.massive }}</td>
            <td v-if="props.item.status === 'Aprobado'">
              <v-btn small color="primary" @click="openFacturarDialog(props.item)">FACTURAR</v-btn>
            </td>
            <td v-if="props.item.status === 'Ingresado' || props.item.status === 'Pagado'">
              <v-icon @click="openDialog(props.item)" style="margin-left: 35px;" color="primary">fa fa-eye</v-icon>

            </td>
          </tr>
        </template>
        <template slot="no-data">
          <div>{{ $t('message.noPreliquidations') }}</div>
        </template>
        <template slot="pageText" slot-scope="props">{{ props.pageStart }} - {{ props.pageStop }} {{ $t('message.of') }}
          {{ props.itemsLength }}</template>
      </v-data-table>
    </v-card-text>
    <FacturarDialog :show="showFacturarDialog" @close="closeFacturarDialog"
      :totalIncome="selectedItem ? selectedItem.printedTotal : 0"
      :numberLiquidation="numberLiquidation" :tipo="3" 
      :totalAvances="selectedItem ? selectedItem.TotalAvances : 0"
      :soloUnaFactura = "soloUnaFactura"
      />
    <FacturaVisualizaDialog :show="showDialog" :factura="selectedFactura" @close="closeDialog"
      :numeroLiquidacion="numberLiquidation" :tipo="3" />
  </v-card>
</template>


<script>
import { mapGetters } from "vuex";
import { nzDate } from "@/common/helpers/helpers";
import { i18n } from "@/main";
import moment from "moment";
import FacturarDialog from "@/components/Facturacion/FacturarDialogComisiones";
import FacturaVisualizaDialog from "@/components/Facturacion/FacturaVisualizaDialog";

export default {
  computed: {
    ...mapGetters(["loadingCommission", "commissionsLiquidation", "agency"]),
    payDateFromDisplay() {
      return this.payDateFrom
        ? moment(this.payDateFrom, "YYYY-MM-DD").format("DD/MM/YYYY")
        : "";
    },
    payDateToDisplay() {
      return this.payDateTo
        ? moment(this.payDateTo, "YYYY-MM-DD").format("DD/MM/YYYY")
        : "";
    }
  },
  components: {
    FacturarDialog,
    FacturaVisualizaDialog
  },
  mounted() {
    this.payDateFrom = moment()
      .subtract(2, "months")
      .format("YYYY-MM-DD");
    this.payDateTo = moment().format("YYYY-MM-DD");
    this.$store.dispatch(
      "getCommissionsLiquidation",
      this.buildLiquidationPayload()
    );

    /*     for(let i=0;i<=this.commissionsLiquidation.length; i++)
     {
       this.selectRow.push(this.commissionsLiquidation[i]);       
     } */
  },
  methods: {
    moment,
    nzDate: nzDate,
    buildLiquidationPayload() {
      const p = {};
      if (this.searchValue) {
        p.any = this.searchValue;
      }
      if (this.payDateFrom && this.payDateTo) {
        p.fechaPagoDesde = this.payDateFrom;
        p.fechaPagoHasta = this.payDateTo;
      }
      return Object.keys(p).length ? p : undefined;
    },
    applyDateFilter() {
      if (!this.payDateFrom || !this.payDateTo) {
        this.$root.$emit(
          "showSnackBar",
          "Seleccione fecha de pago inicio y fecha final",
          "warning"
        );
        return;
      }
      if (moment(this.payDateFrom).isAfter(moment(this.payDateTo))) {
        this.$root.$emit(
          "showSnackBar",
          "La fecha inicial no puede ser posterior a la fecha final",
          "warning"
        );
        return;
      }
      this.$store.dispatch(
        "getCommissionsLiquidation",
        this.buildLiquidationPayload()
      );
    },
    clearDateFilter() {
      this.payDateFrom = null;
      this.payDateTo = null;
      const p = {};
      if (this.searchValue) {
        p.any = this.searchValue;
      }
      this.$store.dispatch(
        "getCommissionsLiquidation",
        Object.keys(p).length ? p : undefined
      );
    },
    uniqueCheck(e, index) {
      let select = this.selectRow[index];
      for (let i = 0; i < this.selectRow.length; i++) {
        if (index != i) {
          this.selectRow[i] = false;
        }
      }
      if (!this.selectRow[index]) {
        this.selectedValue = null;
      } else {
        this.selectedValue = e;
      }
    },
    customSort(items, index, isDesc) {
      items.sort((a, b) => {
        if (index === "creationDate") {
          let dateA = new Date(this.getDate(a[index]));
          let dateB = new Date(this.getDate(b[index]));
          /* let demoInvalidDate=new Date(a[index])
            if(demoInvalidDate=='Invalid Date'){
              var formattedA = moment(a[index]).format('D MMMM YYYY');
              //var formattedB = moment(demoInvalidDate).format('D MMMM YYYY');
              console.log(a[index],formattedA)
           
            } */
          if (!isDesc) {
            return dateA < dateB ? -1 : 1;
          } else {
            return dateB < dateA ? -1 : 1;
          }
        } else {
          if (!isDesc) {
            return a[index] < b[index] ? -1 : 1;
          } else {
            return b[index] < a[index] ? -1 : 1;
          }
        }
      });
      return items;
    },
    openFacturarDialog(item) {
      this.soloUnaFactura = (item.TotalAvances || 0) > 0;
      console.log( this.soloUnaFactura)
      console.log(item.TotalAvances)
      this.selectedItem = item;
      this.showFacturarDialog = true;
      this.numberLiquidation = item.number;
    },
    getDate(d) {
      var day, month, year;

      let result = String(d).match("[0-9]{2}([-/ .])[0-9]{2}[-/ .][0-9]{4}");
      if (null != result) {
        let dateSplitted = result[0].split(result[1]);
        day = dateSplitted[0];
        month = dateSplitted[1];
        year = dateSplitted[2];
      }
      result = String(d).match("[0-9]{4}([-/ .])[0-9]{2}[-/ .][0-9]{2}");
      if (null != result) {
        let dateSplitted = result[0].split(result[1]);
        day = dateSplitted[2];
        month = dateSplitted[1];
        year = dateSplitted[0];
      }

      if (month > 12) {
        let aux = day;
        day = month;
        month = aux;
      }

      return year + "/" + month + "/" + day;
    },
    changeSort(column) {
      this.selectedValue = null;
      (this.selectRow = []), (this.additional_grouped = []);
      if (this.pagination.sortBy === column) {
        this.pagination.descending = !this.pagination.descending;
        this.additional_grouped[0] = this.selectedValue;
      } else {
        this.pagination.sortBy = column;
        this.pagination.descending = false;
        this.additional_grouped[0] = this.selectedValue;
      }
      // console.log(this.pagination.sortBy)
    },
    refresh() {
      this.$store
        .dispatch("getCommissionsLiquidation", this.buildLiquidationPayload())
        .then(() => {
          this.selectedValue = null;
          this.additional_grouped = [];
        });
    },
    enter() {
      this.$store.dispatch(
        "getCommissionsLiquidation",
        this.buildLiquidationPayload()
      );
    },
    closeDialog() {
      this.showDialog = false;
      this.selectedFactura = null;
    },
    async openDialog(item) {

      // Verifica que el item no sea nulo o indefinido
      if (item) {
        // Asignamos el valor de selectedFactura


        // Esperamos hasta que Vue termine de actualizar el DOM
        await this.$nextTick();
        this.numberLiquidation = item.number;

        // Abre el diálogo una vez que todo se haya actualizado
        this.showDialog = true;
      } else {
        console.error("El item no está definido o es nulo.");
      }
    },
    closeFacturarDialog() {
      this.showFacturarDialog = false;
      this.selectedItem = null;
      this.refresh();
    },
  },
  watch: {
    loadingCommission(val) {
      if (val) {
        this.$root.$emit(
          "showLoading",
          "Cargando información, por favor espere..."
        );
      } else {
        this.$root.$emit("hideLoading");
      }
    },
    selectedValue(val) {
      let data = [val];
      this.$store.dispatch("updateCommissionSelected", data);
    },
    agency(val) {
      this.$store.dispatch(
        "getCommissionsLiquidation",
        this.buildLiquidationPayload()
      );
    },


  },
  data() {
    return {
      payDateFrom: null,
      payDateTo: null,
      menuPayFrom: false,
      menuPayTo: false,
      showDialog: false,
      soloUnaFactura: false,
      selectedFactura: null,
      showFacturarDialog: false,
      selectedValue: null,
      selectedItem: null,
      numberLiquidation: '0',
      selectRow: [],
      additional_grouped: [],
      searchValue: "",
      matches: [],
      pagination: {
        sortBy: "creationDate"
      },
      selected: [],
      headers: [
        {
          align: "left",
          sortable: false,
          text: "",
          value: "",
          width: "1%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.date"),
          value: "creationDate",
          width: "13%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.liquidation"),
          value: "number",
          width: "13%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.branch"),
          value: "vtAgency",
          width: "13%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.agent"),
          value: "apsCode",
          width: "13%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.toPay"),
          value: "printedTotal",
          width: "13%"
        },
        {
          align: "left",
          sortable: true,
          text: i18n.t("message.status"),
          value: "status",
          width: "13%"
        },
        {
          align: "left",
          sortable: true,
          text: "Fecha de Pago",
          value: "payDate",
          width: "13%"
        },
        {
          align: "left",
          sortable: true,
          text: "Es Masivo",
          value: "massive",
          width: "13%"
        }

      ]
    };
  }
};
</script>
<style scoped>
.liquidation-query-toolbar {
  overflow-x: auto;
}

.liquidation-toolbar-outer {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-end;
  justify-content: flex-start;
  width: 100%;
}

.liquidation-toolbar-refresh {
  flex: 0 0 auto;
  margin: 0 8px 2px 0;
}

.liquidation-toolbar-group-right {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: flex-end;
  gap: 8px;
  margin-left: auto;
  min-width: 0;
}

.liquidation-toolbar-search {
  flex: 0 1 200px;
  min-width: 140px;
  max-width: 260px;
  padding-top: 0 !important;
  margin-bottom: 0 !important;
}

.liquidation-toolbar-date {
  flex: 0 1 150px;
  min-width: 130px;
  max-width: 180px;
}

.liquidation-toolbar-actions {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  flex: 0 0 auto;
  align-items: flex-end;
  gap: 6px;
  margin-bottom: 2px;
}

.liquidation-toolbar-btn {
  flex: 0 0 auto;
  margin: 0;
  text-transform: uppercase;
  font-weight: 500;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12);
}
</style>